import React, { useState } from 'react'
import { makeStyles, Tabs } from '@material-ui/core'
import SectionTab from './SectionTab'
import SectionTreeView from './SectionTreeView'
import LegacySectionView from './LegacySectionView'

const useStyle = makeStyles((theme) => ({
  flexContainer: {
    [theme.breakpoints.up('md')]: {
      flexWrap: 'wrap',
    },
    paddingBottom: theme.spacing(3),
  },
  indicator: {
    display: 'none',
  },
}))

const Referential = ({
  referential,
  version,
  selectSectionText,
  ariaLabel = '',
}) => {
  const classes = useStyle()
  const [selectedTab, setSelectedTab] = useState(0)

  const handleChange = (e, tab) => {
    setSelectedTab(tab)
    document
      .getElementById(`criteria${referential[tab].criterias[0].id}`)
      .focus()
  }

  return (
    <>
      <Tabs
        variant="scrollable"
        value={selectedTab}
        onChange={(e, tab) => handleChange(e, tab)}
        classes={{
          root: classes.root,
          flexContainer: classes.flexContainer,
          indicator: classes.indicator,
        }}
      >
        {referential.map((section, id) => {
          const sectionName =
            version === '1' ? section.section_name : section.name

          return (
            <SectionTab
              id={`SectionTab${id}`}
              ariaLabel={ariaLabel}
              key={sectionName}
              label={sectionName}
            />
          )
        })}
      </Tabs>
      {referential.map((section, index) =>
        version === '2' ? (
          <SectionTreeView
            key={section.id}
            section={section}
            hidden={index !== selectedTab}
            selectSectionText={selectSectionText}
          />
        ) : (
          <LegacySectionView
            key={section.section_name}
            section={section}
            hidden={index !== selectedTab}
          />
        ),
      )}
    </>
  )
}

export default Referential
